import React from 'react'
import ImageUrlModal from './ImageUrlModal'

class ImageUrlModalContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {}
  }

  componentDidMount () {
  }

  render () {
    return <ImageUrlModal {...this.props} {...this.state} />
  }
}

ImageUrlModalContainer.propTypes = {}

export default ImageUrlModalContainer



// WEBPACK FOOTER //
// ./src/components/ImageUrlModal/ImageUrlModalContainer.js